export default __webpack_public_path__ + "static/media/elle8.cad79225.webp";